import React, { useState, useEffect } from "react";
import _ from "lodash";
import PharmacySelect from "./PharmacySelect";
import NotPermitted from "../../shared/designations/NotPermitted";

const LdnDesignationForm = ({
  manufacturerFormDetails,
  manufacturer,
  setManufacturerFormDetails,
  entities,
  productName,
  isBlocked,
}) => {
  const [singlePharmacyDesignation, setSinglePharmacyDesignation] = useState(false);
  const [confirmedPolicy, setConfirmedPolicy] = useState(false);
  const [hasSelectedPharmacy, setHasSelectedPharmacy] = useState(false);
  const [selectedPharmacy, setSelectedPharmacy] = useState(false);
  const vanityName = productName.charAt(0).toUpperCase() + productName.slice(1);
  const mfrPolicy = `GlaxoSmithKline's (GSK) contract pharmacy policy permits any 340B covered entity that does not have the ability to dispense ${vanityName.toUpperCase()} to eligible patients to designate a single specialty pharmacy within GSK's limited pharmacy network for this purpose. By designating a specialty pharmacy in this web form, you are acknowledging that your 340B covered entity does not have the ability to dispense ${vanityName.toUpperCase()} to eligible patients and will use this designated pharmacy to do so. \n \n By designating a single contract pharmacy location, you agree to submit 340B claims data for that contract pharmacy location via 340B ESP within 45 days of the date of dispense to your patient.`;
  const mfrDesQuestion = `Would you like to make a single contract pharmacy designation for GlaxoSmithKline's specialty limited distribution product, ${vanityName}?`;
  const mfrDesSubtitle = `Contract Pharmacy Designation for ${vanityName}`;

  useEffect(() => {
    const formDetails = _.cloneDeep(manufacturerFormDetails);
    formDetails[manufacturer].singlePharmacyDesignationForm = {
      open: singlePharmacyDesignation,
      completed: hasSelectedPharmacy,
    };
    setManufacturerFormDetails(formDetails);
  }, [singlePharmacyDesignation, hasSelectedPharmacy]);

  const policies = () => {
    if (isBlocked) {
      return <NotPermitted confirmedPolicy={confirmedPolicy} />;
    }

    return (
      <div
        className={
          confirmedPolicy
            ? "designation_form__section__group__step__toggle_container designation_form__section__group__step__toggle_container--closed"
            : "designation_form__section__group__step__toggle_container"
        }
      >
        <div className="stat-cards__confirmation stat-cards__confirmation--disabled">
          <span style={{ whiteSpace: "pre-line" }}>{mfrPolicy}</span>
          {renderConfirmation()}
        </div>
      </div>
    );
  };

  const renderSinglePharmacyDesignationForm = () => {
    return (
      <div className="designation_form__section__group">
        <div className="designation_form__section__group__row">
          <div className="designation_form__section__group__question">
            <div className="designation_form__section__group__question__subtitle">
              {mfrDesSubtitle}
            </div>
            {mfrDesQuestion}
          </div>
          <div className="designation_form__section__group__value">
            <div className="btn__option__group">
              <div
                className={
                  singlePharmacyDesignation ? "btn btn--small btn--selected" : "btn btn--small"
                }
                onClick={() => setSinglePharmacyDesignation(true)}
              >
                yes
              </div>
              <div
                className={
                  singlePharmacyDesignation ? "btn btn--small" : "btn btn--small btn--selected"
                }
                onClick={() => setSinglePharmacyDesignation(false)}
              >
                no
              </div>
            </div>
          </div>
        </div>
        {renderPolicy()}
        {renderStep()}
      </div>
    );
  };

  const renderConfirmation = () => {
    return (
      <div className="stat-cards__confirmation__footer">
        <span>
          <div className="indicator indicator--red indicator--pulse" style={{ marginTop: 3 }}></div>
          Please confirm that you have read the manufacturer's policy and agree to its terms to
          continue.
        </span>
        <span>
          <div className="btn btn--ib btn--tiny" onClick={() => setConfirmedPolicy(true)}>
            Confirm
          </div>
        </span>
      </div>
    );
  };

  const renderStepIndicator = (step) => {
    if (step) {
      return (
        <div className="designation_form__section__group__step__indicator designation_form__section__group__step__indicator--complete">
          <i className="solid solid-budicon-check-ui" />
        </div>
      );
    } else {
      return <div className="designation_form__section__group__step__indicator"></div>;
    }
  };

  const renderPolicy = () => {
    if (singlePharmacyDesignation) {
      return (
        <div className="designation_form__section__group__step">
          {renderStepIndicator(confirmedPolicy)}
          <div className="designation_form__section__group__step__title">Policy Confirmation</div>
          <div className="designation_form__section__group__step__subtitle">
            Please confirm policy before assigning designation
          </div>
          {policies()}
        </div>
      );
    }
  };

  const filterPharmacies = (entity) => {
    return _.filter(entity.pharmacies.details, { [manufacturer]: [productName] });
  };

  const renderPharmacySelect = () => {
    return _.map(entities, (entity, index) => (
      <div key={index}>
        <PharmacySelect
          kind={productName}
          renderMap={false}
          entity={entity}
          pharmacies={filterPharmacies(entity)}
          manufacturer={manufacturer}
          disableGranteeNotice={true}
          disableWhollyOwnedNotice={false}
          disableInHouseSpecialtyNotice={true}
          disableInHouseNotice={true}
          selectedPharmacy={selectedPharmacy}
          setSelectedPharmacy={setSelectedPharmacy}
          setHasSelectedPharmacy={setHasSelectedPharmacy}
        />
      </div>
    ));
  };

  const renderStep = () => {
    if (singlePharmacyDesignation && confirmedPolicy) {
      return (
        <div className="designation_form__section__group__step">
          {renderStepIndicator(hasSelectedPharmacy)}
          <div className="designation_form__section__group__step__title">
            Select Contract Pharmacy
          </div>
          <div className="designation_form__section__group__step__subtitle">
            Please select a contract pharmacy to designate.
          </div>
          {renderPharmacySelect()}
        </div>
      );
    }
  };

  return renderSinglePharmacyDesignationForm();
};

export default LdnDesignationForm;
